<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<div class="container">
    <div class="row">
        <div class="col-8 mb-3 text-center">
            <div class="input-group find-user">
                <span class="input-group-text" id="dni"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Introduce un dni" aria-label="dni"
                    aria-describedby="dni" [(ngModel)]="dni" (keypress)="onKeyPress($event)" i18n-placeholder>
                <button type="button" class="btn btn-primary" (click)="findUser()" i18n>BUSCAR</button>
            </div>
        </div>
        <div class="col-4 text-right">
            <button type="button" class="btn btn-success" (click)="showCreateUser()" i18n>Nuevo solicitante</button>
        </div>
    </div>

    <div class="mb-3" *ngIf="applicant">

        <ul class="nav nav-tabs primary" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane"
                    type="button" role="tab" aria-controls="user-tab-pane" aria-selected="true"
                    i18n>Solicitante</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="vehicles-tab" data-bs-toggle="tab" data-bs-target="#vehicles-tab-pane"
                    type="button" role="tab" aria-controls="vehicles-tab-pane" aria-selected="false"
                    [disabled]="showNew" i18n>Vehículos</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="access-tab" data-bs-toggle="tab" data-bs-target="#access-tab-pane"
                    type="button" role="tab" aria-controls="access-tab-pane" aria-selected="false" [disabled]="showNew"
                    i18n>Accesos</button>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="user-tab-pane" role="tabpanel" tabindex="0">
                <h2 class="my-4" i18n>Tipo de solicitante</h2>

                <div class="card">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="tipo-solicitante" class="form-label">
                                <span i18n>Tipo de solicitante</span>: <span class="required"
                                    title="obligatorio">*</span>
                            </label>
                            <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.applicantType"
                                (ngModelChange)="clearOtherForms()" required
                                [ngClass]="{'is-invalid': shouldShowError('applicantType', applicant.applicantType)}"
                                (blur)="markAsTouched('applicantType')">
                                <option value="" i18n>Seleccione tipo</option>
                                <option value="Individual" i18n>Individual</option>
                                <option value="Represented" i18n>Representado</option>
                                <option value="Company" i18n>Compañia</option>
                            </select>
                            <div *ngIf="shouldShowError('applicantType', applicant.applicantType)"
                                class="invalid-feedback" i18n>
                                Campo requerido
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="applicant.applicantType == 'Individual' && applicant.individual">
                    <h2 class="my-4" i18n>Datos del interesado</h2>

                    <div class="card">
                        <div class="row">
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="nombre" class="form-label">
                                    <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="nombre"
                                    [(ngModel)]="applicant.individual.applicantIdentification.name"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualName', applicant.individual.applicantIdentification.name)}"
                                    (blur)="markAsTouched('individualName')">
                                <div *ngIf="shouldShowError('individualName', applicant.individual.applicantIdentification.name)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="primer-apellido" class="form-label">
                                    <span i18n>Primer apellido</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="primer-apellido"
                                    [(ngModel)]="applicant.individual.applicantIdentification.firstSurname"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)}"
                                    (blur)="markAsTouched('individualFirstSurname')">
                                <div *ngIf="shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="segundo-apellido" class="form-label">
                                    <span i18n>Segundo apellido</span>:
                                </label>
                                <input type="text" class="form-control" id="segundo-apellido"
                                    [(ngModel)]="applicant.individual.applicantIdentification.secondSurname">
                            </div>

                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="fecha-nacimiento" class="form-label">
                                    <span i18n>Fecha de nacimiento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="date" class="form-control" id="fecha-nacimiento"
                                    [(ngModel)]="applicant.individual.applicantIdentification.dateOfBirth.date"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)}"
                                    (blur)="markAsTouched('individualDateOfBirth')">
                                <div *ngIf="shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="tipo-documento" class="form-label">
                                    <span i18n>Tipo de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <select id="tipo-documento" class="form-select"
                                    [(ngModel)]="applicant.individual.applicantIdentification.documentType"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)}"
                                    (blur)="markAsTouched('individualDocumentType')">
                                    <option value="">Seleccione una opción</option>
                                    <option value="NIF">NIF</option>
                                    <option value="NIE">NIE</option>
                                    <option value="Passport">Pasaporte</option>
                                    <option value="National ID">ID nacional</option>
                                </select>
                                <div *ngIf="shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="firstname" class="form-label">
                                    <span i18n>Numéro de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="firstname"
                                    [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)}"
                                    (blur)="markAsTouched('individualDocumentIdentification')">
                                <div *ngIf="shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 mb-3">
                                <label for="email" class="form-label">
                                    <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="email" required
                                    [(ngModel)]="applicant.individual.applicantContact.email"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualEmail', applicant.individual.applicantContact.email)}"
                                    (blur)="markAsTouched('individualEmail')">
                                <div *ngIf="shouldShowError('individualEmail', applicant.individual.applicantContact.email)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <div class="col-sm-6 mb-3">
                                <label for="email" class="form-label">
                                    <span i18n>Confirma email</span>: <span class="required"
                                        title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="email" required [(ngModel)]="confirmEmail"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('individualConfirmEmail', confirmEmail)}"
                                    (blur)="markAsTouched('individualConfirmEmail')">
                                <div *ngIf="shouldShowError('individualConfirmEmail', confirmEmail)"
                                    class="invalid-feedback" i18n>
                                    El email no coincide
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="applicant.applicantType == 'Represented' && applicant.represented">
                    <h2 class="my-4" i18n>Datos del interesado</h2>

                    <div class="card">
                        <div class="row">
                            <!-- Nombre -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="nombre" class="form-label">
                                    <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="nombre"
                                    [(ngModel)]="applicant.represented.applicantIdentification.name"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedName', applicant.represented.applicantIdentification.name)}"
                                    (blur)="markAsTouched('representedName')">
                                <div *ngIf="shouldShowError('representedName', applicant.represented.applicantIdentification.name)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Primer apellido -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="primer-apellido" class="form-label">
                                    <span i18n>Primer apellido</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="primer-apellido"
                                    [(ngModel)]="applicant.represented.applicantIdentification.firstSurname"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)}"
                                    (blur)="markAsTouched('representedFirstSurname')">
                                <div *ngIf="shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Segundo apellido (opcional) -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="segundo-apellido" class="form-label">
                                    <span i18n>Segundo apellido</span>:
                                </label>
                                <input type="text" class="form-control" id="segundo-apellido"
                                    [(ngModel)]="applicant.represented.applicantIdentification.secondSurname">
                            </div>
                            <!-- Fecha de nacimiento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="fecha-nacimiento" class="form-label">
                                    <span i18n>Fecha de nacimiento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="date" class="form-control" id="fecha-nacimiento"
                                    [(ngModel)]="applicant.represented.applicantIdentification.dateOfBirth.date"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)}"
                                    (blur)="markAsTouched('representedDateOfBirth')">
                                <div *ngIf="shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Tipo de documento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="tipo-documento" class="form-label">
                                    <span i18n>Tipo de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <select id="tipo-documento" class="form-select"
                                    [(ngModel)]="applicant.represented.applicantIdentification.documentType"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)}"
                                    (blur)="markAsTouched('representedDocumentType')">
                                    <option value="">Seleccione una opción</option>
                                    <option value="NIF">NIF</option>
                                    <option value="NIE">NIE</option>
                                    <option value="Passport">Pasaporte</option>
                                    <option value="National ID">ID nacional</option>
                                </select>
                                <div *ngIf="shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Número de documento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="firstname" class="form-label">
                                    <span i18n>Numéro de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="firstname"
                                    [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)}"
                                    (blur)="markAsTouched('representedDocumentIdentification')">
                                <div *ngIf="shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Email -->
                            <div class="col-sm-6 mb-3">
                                <label for="email" class="form-label">
                                    <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="email" required
                                    [(ngModel)]="applicant.represented.applicantContact.email"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedEmail', applicant.represented.applicantContact.email)}"
                                    (blur)="markAsTouched('representedEmail')">
                                <div *ngIf="shouldShowError('representedEmail', applicant.represented.applicantContact.email)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                            <!-- Confirmar email -->
                            <div class="col-sm-6 mb-3">
                                <label for="confirm-email" class="form-label">
                                    <span i18n>Confirma email</span>: <span class="required"
                                        title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="confirm-email" required
                                    [(ngModel)]="confirmEmail" (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('representedConfirmEmail', confirmEmail)}"
                                    (blur)="markAsTouched('representedConfirmEmail')">
                                <div *ngIf="shouldShowError('representedConfirmEmail', confirmEmail)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="applicant.applicantType == 'Company' && applicant.company">
                    <h2 class="my-4" i18n>Datos del interesado</h2>

                    <div class="card">
                        <div class="row">
                            <!-- Nombre de la empresa -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="nombre" class="form-label">
                                    <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="nombre"
                                    [(ngModel)]="applicant.company.applicantIdentification.name"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyName', applicant.company.applicantIdentification.name)}"
                                    (blur)="markAsTouched('companyName')">
                                <div *ngIf="shouldShowError('companyName', applicant.company.applicantIdentification.name)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Primer apellido -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="primer-apellido" class="form-label">
                                    <span i18n>Primer apellido</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="primer-apellido"
                                    [(ngModel)]="applicant.company.applicantIdentification.firstSurname"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)}"
                                    (blur)="markAsTouched('companyFirstSurname')">
                                <div *ngIf="shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Segundo apellido (opcional) -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="segundo-apellido" class="form-label">
                                    <span i18n>Segundo apellido</span>:
                                </label>
                                <input type="text" class="form-control" id="segundo-apellido"
                                    [(ngModel)]="applicant.company.applicantIdentification.secondSurname">
                            </div>

                            <!-- Fecha de nacimiento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="fecha-nacimiento" class="form-label">
                                    <span i18n>Fecha de nacimiento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="date" class="form-control" id="fecha-nacimiento"
                                    [(ngModel)]="applicant.company.applicantIdentification.dateOfBirth.date"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)}"
                                    (blur)="markAsTouched('companyDateOfBirth')">
                                <div *ngIf="shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Tipo de documento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="tipo-documento" class="form-label">
                                    <span i18n>Tipo de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <select id="tipo-documento" class="form-select"
                                    [(ngModel)]="applicant.company.applicantIdentification.documentType"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)}"
                                    (blur)="markAsTouched('companyDocumentType')">
                                    <option value="">Seleccione una opción</option>
                                    <option value="NIF">NIF</option>
                                    <option value="NIE">NIE</option>
                                    <option value="Passport">Pasaporte</option>
                                    <option value="National ID">ID nacional</option>
                                </select>
                                <div *ngIf="shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Número de documento -->
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="firstname" class="form-label">
                                    <span i18n>Numéro de documento</span>: <span class="required"
                                        title="obligatorio">*</span>
                                </label>
                                <input type="text" class="form-control" id="firstname"
                                    [(ngModel)]="applicant.company.applicantIdentification.documentIdentification"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)}"
                                    (blur)="markAsTouched('companyDocumentIdentification')">
                                <div *ngIf="shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Email -->
                            <div class="col-sm-6 mb-3">
                                <label for="email" class="form-label">
                                    <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="email" required
                                    [(ngModel)]="applicant.company.applicantContact.email"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyEmail', applicant.company.applicantContact.email)}"
                                    (blur)="markAsTouched('companyEmail')">
                                <div *ngIf="shouldShowError('companyEmail', applicant.company.applicantContact.email)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>

                            <!-- Confirmar email -->
                            <div class="col-sm-6 mb-3">
                                <label for="email" class="form-label">
                                    <span i18n>Confirma email</span>: <span class="required"
                                        title="Obligatorio">*</span>
                                </label>
                                <input type="email" class="form-control" id="email" required [(ngModel)]="confirmEmail"
                                    (ngModelChange)="checkValid()" required
                                    [ngClass]="{'is-invalid': shouldShowError('companyConfirmEmail', confirmEmail)}"
                                    (blur)="markAsTouched('companyConfirmEmail')">
                                <div *ngIf="shouldShowError('companyConfirmEmail', confirmEmail)"
                                    class="invalid-feedback" i18n>
                                    Campo requerido
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 class="my-4" i18n>Datos de contacto del interesado</h2>

                    <div class="card">
                        <div class="row">
                            <div class="col-sm-6 mb-3">
                                <label for="telefono" class="form-label">
                                    <span i18n>Teléfono de contacto</span>:
                                </label>
                                <input type="text" class="form-control" id="telefono"
                                    [(ngModel)]="applicant.company.applicantContact.phoneNumber">
                            </div>
                            <div class="col-sm-6 mb-3">
                                <label for="pais-residencia" class="form-label">
                                    <span i18n>País de residencia</span>:
                                </label>
                                <select id="pais-residencia" class="form-select"
                                    [(ngModel)]="applicant.company.applicantContact.countryCode">
                                    <option value="0" i18n>Selecciona un país</option>
                                    @for (country of countries; track country.code) {
                                    <option value="{{country.code}}">{{country.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                <select id="provincia" class="form-select"
                                    [(ngModel)]="applicant.company.applicantContact.province"
                                    (ngModelChange)="loadMunicipalities()">
                                    <option value="" i18n>Selecciona una provincia</option>
                                    @for (province of provinces; track province.code) {
                                    <option value="{{province.name}}">{{province.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                <select id="provincia" class="form-select"
                                    [(ngModel)]="applicant.company.applicantContact.municipality"
                                    [disabled]="applicant.company.applicantContact.province == ''">
                                    <option value="" i18n>Selecciona un municipio</option>
                                    @for (municipality of municipalities; track municipality.code) {
                                    <option value="{{municipality.name}}">{{municipality.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-sm-6 col-xl-4 mb-3">
                                <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                <input type="text" class="form-control" id="cp"
                                    [(ngModel)]="applicant.company.applicantContact.postalCode">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                <select id="stret-type" class="form-select"
                                    [(ngModel)]="applicant.company.applicantContact.streetTypeCode">
                                    <option value="" i18n>Selecciona un tipo de vía</option>
                                    @for (strTyp of streetTypes; track strTyp.code) {
                                    <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-sm-6 col-xl-6 mb-3">
                                <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                <input type="text" class="form-control" id="nombre-via"
                                    [(ngModel)]="applicant.company.applicantContact.streetName">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                <input type="text" class="form-control" id="numero"
                                    [(ngModel)]="applicant.company.applicantContact.streetNumber">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                <input type="text" class="form-control" id="piso"
                                    [(ngModel)]="applicant.company.applicantContact.floor">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                <input type="text" class="form-control" id="puerta"
                                    [(ngModel)]="applicant.company.applicantContact.door">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                <input type="text" class="form-control" id="stairCase"
                                    [(ngModel)]="applicant.company.applicantContact.stairCase">
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-3">
                                <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                <input type="text" class="form-control" id="block"
                                    [(ngModel)]="applicant.company.applicantContact.block">
                            </div>
                        </div>
                    </div>
                </ng-container>

                <h2 class="my-4" i18n>¿Por qué medio quiere ser comunicado?</h2>
                <div class="card mb-3">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-3">
                            <div class="row pt-2">
                                <div class="col-12">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" role="switch" id="email-check"
                                            [(ngModel)]="applicant!.flags!.email" (change)="changeFlag('email')">
                                        <label class="form-check-label" for="email-check" i18n>Recibir notificaciones
                                            por email</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" role="switch" id="sms"
                                            [(ngModel)]="applicant!.flags!.sms" (change)="changeFlag('sms')">
                                        <label class="form-check-label" for="sms" i18n>Recibir notificaciones por
                                            sms</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 mb-3">
                            <label for="language" i18n>Idioma notificación: </label>
                            <select class="form-select" id="language" [(ngModel)]="applicant!.flags!.language"
                                (change)="changeFlag('language')">
                                <option value="" i18n>Selecciona Idioma</option>
                                <option value="ca-ES" i18n>Catalan</option>
                                <option value="es-ES" i18n>Español</option>
                                <option value="en-GB" i18n>Ingles</option>
                            </select>
                        </div>

                    </div>
                </div>

                <div *ngIf="showNew">
                    <h6 class="my-4" i18n>Protección de datos</h6>
                    <div class="mb-3 check-legal">
                        <label for="data-treatment" class="ml-3"><span i18n>El firmante responde personalmente sobre la
                                veracidad de
                                los datos manifestados y acepta y es
                                consciente de que, en caso de comprobarse la falsedad de los datos expuestos en la
                                solicitud,
                                perderá
                                cualquier derecho al servicio. </span>
                            <a routerLink="/privacy" target="_blank" i18n>Política de privacidad</a>.</label>
                    </div>
                    <div class="mb-3 check-legal">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.privacity"
                            (ngModelChange)="checkValid()" id="privacy">
                        <label for="privacy" class="ml-3"><span i18n>Acepto la política de privacidad, para mas
                                información
                                haga
                                clic </span><a routerLink="/privacy" target="_blank" i18n>aquí</a>.</label>
                    </div>

                    <div class="check-legal mb-3">
                        <span i18n>En cumplimiento de lo dispuesto en la normativa de protección de datos vigente, se le
                            informa que
                            sus datos serán tratados por los municipios de este <a routerLink="/town-halls">listado</a>,
                            con la
                            finalidad de completar su registro. Puede ejercer sus derechos y obtener más información
                            consultando la
                            <a routerLink="/privacy">Política de Privacidad</a>.</span>
                    </div>

                    <div class="form-check my-4" *ngIf="!isValid">
                        <span class="required" title="Obligatorio">*</span><small class="text-danger" i18n>Por favor,
                            rellene todos
                            los campos obligatorios.</small>
                    </div>
                </div>

                <button type="button" class="btn btn-secondary" i18n (click)="createOrUpdate()">Enviar</button>
            </div>
            <div class="tab-pane fade" id="vehicles-tab-pane" role="tabpanel" tabindex="0">
                <button type="button" class="btn btn-primary" (click)="goBackVehicles()"
                    *ngIf="newException || newVehicle" i18n>Volver</button>
                <app-vehicles *ngIf="!newException && !newVehicle" [applicantId]="applicant.identifier || ''"
                    (clickNewException)="goToNewException($event)" (clickNewVehicle)="newVehicle = true"></app-vehicles>
                <app-exception *ngIf="newException" [applicantId]="applicant.identifier || ''"
                    [selectedVehicle]="selectedVehicle" (goBackEvent)="this.newException = false"></app-exception>
                <app-vehicle *ngIf="newVehicle" [applicantId]="applicant.identifier || ''"
                    (goBackEvent)="this.newVehicle = false" (goNewEvent)="goToNewException($event)"></app-vehicle>
            </div>
            <div class="tab-pane fade" id="access-tab-pane" role="tabpanel" tabindex="0">
                <app-access *ngIf="!newVehicle" [applicantId]="applicant.identifier || ''"
                    (clickNewVehicle)="newVehicle = true"></app-access>
                <app-vehicle *ngIf="newVehicle" [applicantId]="applicant.identifier || ''"
                    (goBackEvent)="this.newVehicle = false" (goNewEvent)="newVehicle = false"></app-vehicle>
            </div>
        </div>
    </div>

    <div class="mb-3" *ngIf="notFoundUser">
        <h2>{{notFoundUser}}</h2>
    </div>
</div>